import { render } from "./DownloadVpos.vue?vue&type=template&id=c904b042"
import script from "./DownloadVpos.vue?vue&type=script&lang=js"
export * from "./DownloadVpos.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__